import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import './sentry';
import * as pdfjsLib from 'pdfjs-dist';

enableProdMode();
(pdfjsLib as any).GlobalWorkerOptions.isEvalSupported = false;
platformBrowserDynamic().bootstrapModule(AppModule);
